import {
    fetchBackofficeEntities, fetchEntityDetailsByEntityId, editEntity, deleteEntityByEntityId,
    getEntityGroupsDropdown,
    getEntityCompanyDropdown,
    getGNPrincipalDropdown,
    getDBGSCInstalationsDropdown,
    registerNewEntity,
    getSearchByPostalCode,
    fetchBusinessManagerPincipalList,
    getExtranetInstallations,
    getInstances,
} from "../../api/backoffice";
import {
    getInstalationsDropdown
} from "../../api/authentication";
import Vue from "vue";
import i18n from "@/i18n";
import store from "@/store";
//import { bus } from '@/utils/event-bus';

const hasInvalidValue = (v) => {
    return v.value == null || v.value === "";
};


const getDefaultState = () => {
    return {
        // ******* Backoffice entity details *************
        entityBkoForm: {},
        entityDetails: {},
        entityDetailsDropdown: {
            nationalityList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: "PT",
                text: i18n.t("global.country.portugal"),
            }, {
                value: "ES",
                text: i18n.t("global.country.spain"),
            }],
            entityCompanyList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            gnPrincipalList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            entityGroupList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            instalationGSCList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            extranetInstallations: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            instancesList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
        },
        containsChanges: false,
        // ******* Backoffice entities list *************
        backofficeEntities: [],
        totalPages: 0,
        totalResults: 0,
        filters: {
            idGroup: "",
            idBusinessManager: "",
            status: "S",
            filter_search: "",
        },
        dropdownsFilters: {
            entityGroups: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            statusList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "Ativo",
                selected: true,
            }, {
                value: 0,
                text: "Inativo",
            }],
            gnsList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
        },
        isTableLoading: false,
    };
};

const state = getDefaultState();

const getters = {
    // ******* Backoffice Entity details *************
    getEntityBkoForm: (state) => state.entityBkoForm,
    getEntityDetails: (state) => state.entityDetails,

    getNationalityList: (state) => state.entityDetailsDropdown.nationalityList,
    getEntityGroupList: (state) => state.entityDetailsDropdown.entityGroupList,
    getEntityCompanyList: (state) => state.entityDetailsDropdown.entityCompanyList,
    getGNPrincipalList: (state) => state.entityDetailsDropdown.gnPrincipalList,
    getInstalationGSCList: (state) => state.entityDetailsDropdown.instalationGSCList,
    getSearchByPostalCode: (state) => (key) => state.entityDetailsDropdown[`locality-${key}`],
    getContainsChanges: (state) => state.containsChanges,
    // ******* Backoffice entities list *************
    getBackofficeEntities: (state) => state.backofficeEntities,
    getEntitiesTotalPages: (state) => state.totalPages,
    getEntitiesTotalResults: (state) => state.totalResults,
    getEntitiesFilledFilters: (state) =>
        Object.fromEntries(
            Object.entries(state.filters).filter(([, v]) => {
                return v != "";
            })
        ),
    getEntitiesFilterByKey: (state) => (key) => state.filters[key],
    getDropdown: (state) => (key) => state.dropdownsFilters[key],
    //getBusinessManagerPincipalList: (state) => state.entityDetailsDropdown.gnsList,
    isTableLoading: (state) => state.isTableLoading,
    getExtranetInstalationList: (state) => state.entityDetailsDropdown.extranetInstallations,
    getInstanceList: (state) => state.entityDetailsDropdown.instancesList,
};

const mutations = {
    // ******* Backoffice entity details *************
    setEntityBkoForm(state, entityBkoForm) {
        state.entityBkoForm = entityBkoForm;
    },
    setEntityDetails(state, entityDetails) {
        state.setEntityDetails = entityDetails;
    },
    resetEntityDetailsDropdownsState(state) {
        state.entityDetailsDropdown = getDefaultState().entityDetailsDropdown;
    },
    setEntitySimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return item["NAME"];
        });
        state[stateType][type] = dropdownNeoObj;
    },
    setEntityCompanySimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            if(item["STATUS"] == "N") {
                return { value: item["ID"], text: item["NAME"], disabled: true, };
            } else {
                return { value: item["ID"], text: item["NAME"] };
            }
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setInstanceSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            if(item["STATUS"] == "N") {
                return { value: item["ID"], text: item["NAME"], disabled: true, };
            } else {
                return { value: item["ID"], text: item["NAME"] };
            }
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setGNsListDropdown(state,
        {
            data,
            stateType,
            type,
        }) {
        let dropdownNeoObj = data.map((item) => {
            return {
                value: item["ID"],
                text: item["NAME"],
            };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setEntityGroupSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return { value: item["ID"], text: item["NAME"] };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setGNPrincipalSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return { value: item["ID"], text: item["NAME"] };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setInstalationGSCSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return { value: item["id"], text: item["name"] };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setExtranetInstalations(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return { value: item["oidDealer"], text: item["name"] };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        
        state[stateType][type] = dropdownNeoObj;
    },
    setPostalCodeFormatDropdown(state,
        {
          data,
          stateType = "proposalDropdowns",
          localityType,
        }) {
        let dropdownNeoObj = data?.locality?.map((item, index) => {
            console.log(index)
          return {
            value: item,
            text: item,
          };
        }) || [];
    
        dropdownNeoObj = [
          {
            value: -1,
            text: i18n.t("dropdownSelection"),
            disabled: true,
          },
          ...dropdownNeoObj,
        ];
        state[stateType][localityType] = dropdownNeoObj;
    },
    setFieldValue(state, { key, value, options, onChangeActions }) {
        console.log(options);
        const idInstance = store.getters["AuthenticationModule/getUserInstanceId"];

        state?.entityBkoForm?.form?.forEach((form) => {
            const field = form.fields.find((f) => f.key === key);
            const installationsGSCField = form.fields.find((f) => f?.key?.startsWith("ID_GSC_INSTALLATION"));
            const installationExtranetField = form.fields.find((f) => f?.key?.startsWith("OID_DEALER"));
            let countryField = form.fields.find((f) => f?.key?.startsWith("COUNTRY"));
            
            if (onChangeActions) {
                onChangeActions.map(async (changeAction) => {
                    if (changeAction.type === "changeCountry" && form?.key === "generalData") {
                        if (value?.value) {
                            countryField.value = value?.value;

                            let cp3Field = form.fields.find((f) => f?.key?.startsWith("CP3"));
                            cp3Field.fieldShow = true;
                            let districtField = form.fields.find((f) => f?.key?.startsWith("DISTRICT"));
                            districtField.colspan = 3;
                            if(value?.value === 'ES') {
                                cp3Field.fieldShow = false;
                                districtField.colspan = 5;
                            }

                            const resp = await this.dispatch("EntityBkoFormModule/getExtranetInstalationList", {country: value?.value, idEntityGroup: -1, idInstance: idInstance} );
                            
                            const extranetInstalationList = resp?.data || [];

                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: installationExtranetField?.key, attribute: 'options', value: extranetInstalationList });
                            this.commit("EntityBkoFormModule/setFieldValue", installationExtranetField);
                            this.commit("EntityBkoFormModule/setIncrementField", { key: installationExtranetField?.key });
                        }   
                    }

                    if (changeAction.type === "changeDBGSCInstallation" && form?.key === "generalData") {

                        if (value?.value) {
                            const response = await this.dispatch("EntityBkoFormModule/getInstalationGSCList", value?.value );
                            const installationsGSC = response?.installationsGSCValue;

                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: installationsGSCField?.key, attribute: 'options', value: installationsGSC });
                            this.commit("EntityBkoFormModule/setFieldValue", installationsGSCField);
                            this.commit("EntityBkoFormModule/setIncrementField", { key: installationsGSCField?.key });
                        }
                    }

                    if (changeAction.type === "fetchPostalCodeDataAddress" && form?.key === "generalData") {
                        const cpExt = form.fields.find((f) => f?.key?.startsWith("CPEXT"));
                        const district = form.fields.find((f) => f?.key?.startsWith("DISTRICT"));
                        let cp4 = form.fields.find((f) => f?.key?.startsWith("CP4"));
            
                        if (changeAction.typeOfPostalCode === "PT" && countryField?.value !== 'ES') {
                          //! PT código postal - é enviado no formulário o cp4 e cp3
                          const cp3 = form.fields.find((f) => f?.key?.startsWith("CP3"));
                          if (value) {
                            if (key.startsWith("CP4")) {
                                cp4.value = value;
                            } else if (key.startsWith("CP3")) {
                                cp3.value = value;
                            }
                          }
                          
                          const cp4Value = cp4?.value?.toString();
                          const cp3Value = cp3?.value?.toString();
                          // Verifica se foi atingido o limite dos caracteres de ambos os campos para fazer a pesquisa do código postal
                          if (cp4Value.length === 4 && cp3?.maxLength === cp3Value.length) {
                            const postalCodeValue = cp4Value + cp3Value;
                            const { districtValue } = await this.dispatch("EntityBkoFormModule/getSearchByPostalCode", { formNationality: "PT", localityFieldKey: cpExt.key, postalCode: postalCodeValue });
                            // Colocar este campo com o tipo de dropdown
                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'type', value: "dropdown" });
            
                            //Distrito
                            district.value = districtValue;
                            district.editable = !districtValue;
                            district.hasError = false;
                            //Cidade
                            cpExt.loading = false;
                            cp4.hasError = false;
            
                            const cityValues = this.getters["EntityBkoFormModule/getSearchByPostalCode"](cpExt.key);
                            if (cityValues?.length > 1) {
                              if (cityValues?.length === 2) {
                                cityValues[1].selected = true;
            
                                // Create a promise to handle the asynchronous update
                                const updateAddress1CityValue = new Promise((resolve) => {
                                  resolve(cityValues[1]?.text);
                                });
            
                                // Update cpExt.value when the promise is resolved
                                updateAddress1CityValue.then((updatedValue) => {
                                    cpExt.value = updatedValue;
                                  console.log(cityValues[1]?.text, cpExt.value);
                                });
                              }
                              this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'options', value: cityValues });
                              this.commit("EntityBkoFormModule/setFieldValue", cpExt);
                              this.commit("EntityBkoFormModule/setIncrementField", { key: cpExt?.key });
                            } else {
                                cpExt.type = "text";
                            }
                          } else {
                            //Distrito
                            district.value = "";
                            district.editable = true;

                            //Cidade
                            cpExt.value = "";
                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'options', value: [] });
                            // Colocar este campo com o tipo de text
                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'type', value: "text" });
                            cpExt.loading = true;
                            this.commit("EntityBkoFormModule/setIncrementField", { key: cpExt?.key });
                          }
                        } else {
                          //! ES código postal - apenas é enviado no formulário o cp4
                          if (value) {
                            if (key.startsWith("CP4")) {
                                cp4.value = value;
                            } 
                          }

                          const cp4Value = cp4?.value?.toString();
                          console.log('cp4Value: ' + cp4Value)
                          //if (cp4?.maxLength === value?.length) {
                          if (value?.length >= 4 && value?.length <= 5) {
                            const { districtValue } = await this.dispatch("EntityBkoFormModule/getSearchByPostalCode", { formNationality: "ES", localityFieldKey: cpExt.key, postalCode: value });
            
                            // Colocar este campo com o tipo de dropdown
                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'type', value: "dropdown" });
                            //Distrito
                            district.value = districtValue;
                            district.editable = !districtValue;
                            district.hasError = false;
                            //Cidade
                            cpExt.loading = false;
                            cp4.hasError = false;
            
                            const cityValues = this.getters["EntityBkoFormModule/getSearchByPostalCode"](cpExt.key);
            
                            if (cityValues?.length > 1) {
                              if (cityValues?.length === 2) {
                                cityValues[1].selected = true;
            
                                // Create a promise to handle the asynchronous update
                                const updateAddress1CityValue = new Promise((resolve) => {
                                  resolve(cityValues[1]?.text);
                                });
            
                                // Update cpExt.value when the promise is resolved
                                updateAddress1CityValue.then((updatedValue) => {
                                    cpExt.value = updatedValue;
                                  console.log(cityValues[1]?.text, cpExt.value);
                                });
                              }
                              this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'options', value: cityValues });
                              this.commit("EntityBkoFormModule/setFieldValue", cpExt);
                              this.commit("EntityBkoFormModule/setIncrementField", { key: cpExt?.key });
                            } else {
                                cpExt.type = "text";
                            }
                          } else {
                            //Distrito
                            district.value = "";
                            district.editable = true;
                            //Cidade
                            cpExt.value = "";
                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'options', value: [] });
                            // Colocar este campo com o tipo de text
                            this.commit("EntityBkoFormModule/setFieldAttribute", { key: cpExt?.key, attribute: 'type', value: "text" });
                            cpExt.loading = true;
                            this.commit("EntityBkoFormModule/setIncrementField", { key: cpExt?.key });
                          }
                          cp4.value = value;
                        }
                    }
                });
            } else {
                if (field) {
                    field.value = value;
                    if (field.type === "dropdown") {
                        field.value = value?.text || value?.value || value;
                    }

                    field.hasError = false;
                }
            }
        });
    },
    setIncrementField(state, { key }) {
        state?.entityBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setFieldAttribute(state, { key, attribute, value }) {

        state?.entityBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            
            if (field) {
                if(!(field.key?.startsWith("CPEXT") || field.key?.startsWith("COUNTRY"))) {
                    let dropdownNeoObj = value?.map((item) => {
                        return { value: item["id"], text: item["name"] };
                    }) || [];
            
                    dropdownNeoObj = [
                        {
                            value: -1,
                            text: i18n.t("dropdownSelection"),
                            disabled: true,
                        },
                        ...dropdownNeoObj,
                    ];
                    
                    field[attribute] = dropdownNeoObj;
                }

                if (!(field.key.startsWith('ID_GSC_INSTALLATION') || field.key.startsWith('OID_DEALER'))) {
                    field[attribute] = value;
                }
            }
        });
    },
    setContainsChanges(state, containsChanges) {
        state.containsChanges = containsChanges;
    },
    // ******* Backoffice entities list *************
    setBackofficeEntities(state, backofficeEntities) {
        state.backofficeEntities = backofficeEntities;
    },
    setEntitiesTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setEntitiesTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setEntitiesFilters(state, entitiesFilters) {
        state.entitiesFilters = entitiesFilters;
    },
    setMixedDropdownValues(
        state,
        {
            data,
            stateType = "dropdownsFilters",
            type,
            valueKey = "ID",
        }
    ) {
        let dropdownNeoObj = data.map((item) => {
            return {
                value: item?.[valueKey],
                text: item?.NAME,
            };
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFilterByKey(state, filter) {
        state.filters[filter.key] = filter.value;
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
};

const actions = {
    // ******* Backoffice entity details *************
    async getEntityDetails({ commit }, entityId) {
        try {
            const response = await fetchEntityDetailsByEntityId(entityId);
            commit("setEntityDetails", response?.data?.data);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async getEntitiesList({ commit }) {
        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getInstalationsDropdown(idInstance);
            const entities = response?.data?.data;
            commit("setEntitySimpleList", {
                data: entities,
                stateType: "entityDetailsDropdown",
                type: "entitiesList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getSearchByPostalCode({ commit }, { localityFieldKey, postalCode, formNationality }) {
        try {
          const response = await getSearchByPostalCode({ postalCode, formNationality });
    
          commit("setPostalCodeFormatDropdown", {
            data: response?.data?.data,
            localityType: "locality-" + localityFieldKey,
            stateType: "entityDetailsDropdown",
          });
    
          return { districtValue: response?.data?.data?.district, municipalityValue: response?.data?.data?.municipality };
    
        } catch (error) {
          console.log(error);
        }
    },
    async checkIfFormIsValid({ commit }) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.entityBkoForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", { field: i18n.t(label) })}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    async registerNewEntity({ commit, rootGetters }, payload) {
        commit("setTableLoading", false);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const data = payload;
            data["ID_INSTANCE"] = payload?.ID_INSTANCE || idInstance;
            const response = await registerNewEntity(data);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    // ******* Backoffice entities list *************
    async getBackofficeEntities({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBackofficeEntities(
                page.page,
                page.orderBy,
                page?.search,
                page?.pageSize,
                idInstance
            );
            commit("setBackofficeEntities", response?.data?.data);
            commit("setEntitiesTotalPages", response?.data?.pages);
            commit("setEntitiesTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async getEntityGroupList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityGroupsDropdown(idInstance);
            const entityGroups = response?.data?.data;
            commit("setMixedDropdownValues", {
                data: entityGroups,
                type: "entityGroups",
            });

            commit("setEntityGroupSimpleList", {
                data: entityGroups,
                stateType: "entityDetailsDropdown",
                type: "entityGroupList",
                valueKey: "ID_GROUP",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getBusinessManagerPincipalList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBusinessManagerPincipalList(idInstance);
            const gnsList = response?.data?.data;
            commit("setMixedDropdownValues", {
                data: gnsList,
                type: "gnsList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getInstanceList({ commit }) {
        try {
            const response = await getInstances();
            const instancesList = response?.data?.data || [];
            
            commit("setInstanceSimpleList", {
                data: instancesList,
                stateType: "entityDetailsDropdown",
                type: "instancesList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getEntityCompanyList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityCompanyDropdown(idInstance);
            const entityCompany = response?.data?.data;
            commit("setEntityCompanySimpleList", {
                data: entityCompany,
                stateType: "entityDetailsDropdown",
                type: "entityCompanyList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getGNPrincipalList({ commit, rootGetters }, entityId) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            if (entityId) {
                const response = await getGNPrincipalDropdown(entityId, idInstance);
                const entityCompany = response?.data?.data;
                commit("setGNPrincipalSimpleList", {
                    data: entityCompany,
                    stateType: "entityDetailsDropdown",
                    type: "gnPrincipalList",
                });
            }
        } catch (error) {
            console.log(error)
        }
    },
    async getInstalationGSCList({ commit }, idEntityCompany) {
        try {
            let installationsGSC = [];
            if (idEntityCompany) {
                const response = await getDBGSCInstalationsDropdown(idEntityCompany);
                installationsGSC = response?.data?.data;
                
                commit("setInstalationGSCSimpleList", {
                    data: installationsGSC,
                    stateType: "entityDetailsDropdown",
                    type: "instalationGSCList",
                });
            }

            return { installationsGSCValue: installationsGSC };
        } catch (error) {
            console.log(error)
        }
    },
    async getExtranetInstalationList({ commit }, {country, idEntityGroup, idInstance}) {
        try {
            if (!country) {  return; }

            const response = await getExtranetInstallations(country, idEntityGroup, idInstance || -1);
            const installations = response?.data?.data || [];
            
            commit("setExtranetInstalations", {
                data: installations,
                stateType: "entityDetailsDropdown",
                type: "extranetInstallations",
            });

            const data = installations?.map((item) => {
                return { id: item["oidDealer"], name: item["name"] };
            }) || [];
            return { data: data };
        } catch (error) {
            console.log(error)
        }
    },
    async deleteEntity({ commit }, entityId) {
        commit("setTableLoading", false);
        try {
            const response = await deleteEntityByEntityId(entityId);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async editEntity({ commit }, { entityId, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await editEntity(entityId, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
